const checkoutChildRoutes = (prop, mode = false) => [
  {
    path: 'guest-info',
    name: `${prop}.guest-info`,
    meta: {
      authRequired: mode,
      title: 'Checkout',
      withHeader: true
    },
    component: () => import('../views/pages/checkout/guestInfo.vue')
  },
  {
    path: 'billing',
    name: `${prop}.billing`,
    meta: {
      authRequired: mode,
      title: 'Checkout',
      withHeader: true
    },
    component: () => import('../views/pages/checkout/billing.vue')
  },
  {
    path: 'order',
    name: `${prop}.order`,
    meta: {
      authRequired: mode,
      title: 'Checkout',
      withHeader: true
    },
    component: () => import('../views/pages/checkout/order.vue')
  },
  {
    path: 'order-completed/:transactionId',
    name: `${prop}.order-completed`,
    meta: {
      authRequired: mode,
      title: '',
      withHeader: true
    },
    component: () => import('../views/pages/checkout/thankyou.vue')
  },
  {
    path: 'receipt/:transactionId/:storeId',
    name: `${prop}.receipt`,
    meta: {
      authRequired: mode,
      title: '',
      withHeader: false
    },
    component: () => import('../views/pages/checkout/receipt.vue')
  }
]

export default checkoutChildRoutes
